import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCol, CForm, CFormInput, CFormLabel, CFormSelect, CFormSwitch, CRow } from "@coreui/react"
import { Divider, Grid } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { getAllBooths } from "src/services/Booths/Booths"
import { createFrameAssignment, getAllFrames, getAllFramesTable, getFrameById } from "src/services/Frames"

const START_HOUR = ' 00:00:00'
const END_HOUR = ' 23:59:59'
const ALL_BOOTH = {
    label: 'Semua Booth',
    value: '0',
}

function AddFrameAssignment() {
    const [boothOptions, setBoothOptions] = useState([])
    const [frameOptions, setFrameOptions] = useState([])
    const [selectedFrame, setSelecteddFrame] = useState(0)
    const [boothCounter, setBoothCounter] = useState(1)
    const [frame, setFrame] = useState({})

    const [selectedBooths, setSelectedBooths] = useState([0])
    const [merchantId, setMerchantId] = useState([0])
    const [isTimePeriod, setIsTimePeriod] = useState([false])
    const [dateFrom, setDateFrom] = useState([''])
    const [dateUntil, setDateUntil] = useState([''])
    const [applyDateForAll, setApplyDateForAll] = useState(false)

    const [validated, setValidated] = useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    const formRef = useRef()

    function handleSetDateForAll(){
        const [firstIsTimePeriod, firstFor, firstUntil] = [isTimePeriod[0], dateFrom[0], dateUntil[0]]
        const tmpIsTimePeriod = isTimePeriod.map(() => {
            return firstIsTimePeriod
        })
        setIsTimePeriod(tmpIsTimePeriod)

        const tmpFor = dateFrom.map(() => {
            return firstFor
        }) 
        setDateFrom(tmpFor)
        
        const tmpUntil = dateUntil.map(() => {
            return firstUntil
        }) 
        setDateUntil(tmpUntil)
    }

    function fetchFrame() {
        getFrameById(location.state.frameId).then(response => {
            setFrame(response.data[0])
        })
    }

    function fetchAllFrame() {
        getAllFrames().then(response => {
            setSelecteddFrame(response.data[0]?.id)
            setFrameOptions(response.data.map(item => {
                return {
                    ...item,
                    value : item.id,
                    label : `${item.id} - ${item.name}`
                }
            }))
        })
    }

    function fetchBooths() {
        getAllBooths().then(response => {
            setSelectedBooths([0])
            setBoothOptions([...response.data.map(item => {
                return {
                    ...item,
                    label: `${item.name} - ${item.id}`,
                    value: item.id
                }
            })])
        })
    }

    async function handleSubmit() {
        if (formRef.current.checkValidity() === true) {
            let data = []
            if (selectedBooths[0] == 0) {
                data = boothOptions.map((x) => {
                    return {
                        merchant_id : x.merchant_id,
                        booth_id : x.id,
                        frame_id : frame.id,
                        is_time_period : isTimePeriod[0] ? 1 : 0,
                        valid_from : isTimePeriod[0] ? dateFrom[0] + START_HOUR : null,
                        valid_until : isTimePeriod[0] ? dateUntil[0] + END_HOUR : null,
                        sequence : frame.sequence 
                    }
                })
            } else {
                data = selectedBooths.map((x, i) => {
                    return {
                        merchant_id : merchantId[i],
                        booth_id : selectedBooths[i],
                        frame_id : frame.id,
                        is_time_period : isTimePeriod[i] ? 1 : 0,
                        valid_from : isTimePeriod[i] ? dateFrom[i] + START_HOUR : null,
                        valid_until : isTimePeriod[i] ? dateUntil[i] + END_HOUR : null,
                        sequence : frame.sequence 
                    }
                })
            }
            createFrameAssignment(data).then(() => {
                navigate('/frames-assignment')
            })
        }
        setValidated(true)
    }

    useEffect(() => {
        if (location.state?.frameId){
            fetchFrame()
        } else {
            fetchAllFrame()
        }
        fetchBooths()
    }, [])

    useEffect(() => {
        setValidated(false)
    }, [isTimePeriod, dateFrom, dateUntil])

    return (
        <>
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol xs={4}>
                            Frame Assignment
                        </CCol>
                        {   !location.state?.frameId &&
                            <>
                                <CCol xs={2}>
                                    <CFormLabel>Select Frame</CFormLabel>
                                </CCol>
                                <CCol xs={6}>
                                    <CFormSelect
                                        options={frameOptions}
                                        onChange={(e) => {
                                            frameOptions.forEach(item => {
                                                if (item.id == e.target.value){
                                                    setFrame(item)
                                                }
                                            })
                                        }}
                                    />
                                </CCol>
                            </>
                        }
                    </CRow>
                </CCardHeader>
                <CCardBody>
                    <CForm className="needs-validation" noValidate validated={validated} ref={formRef}>
                        {[...Array(boothCounter).keys()].map(idx => (
                            <Grid>
                                <Grid container className="mb-2" style={{ justifyContent: 'space-between' }}>
                                    <CFormLabel>{`Booth ${idx + 1}`}</CFormLabel>
                                    {idx == 0 ?
                                        <CButton
                                            onClick={(e) => {
                                                setApplyDateForAll(!applyDateForAll)
                                                handleSetDateForAll()
                                            }}
                                        >
                                            { applyDateForAll ?
                                                'Set Date for Each'
                                                :
                                                'Apply Date for All'
                                            }
                                        </CButton>
                                        :
                                        <CButton
                                            variant="outline"
                                            color="danger"
                                            onClick={(e) => {
                                                setSelectedBooths(
                                                    selectedBooths.filter((x, i) =>
                                                        i !== idx
                                                    )
                                                );
                                                setMerchantId(
                                                    merchantId.filter((x, i) =>
                                                        i !== idx
                                                    )
                                                );
                                                setIsTimePeriod(
                                                    isTimePeriod.filter((x, i) =>
                                                        i !== idx
                                                    )
                                                );
                                                setDateFrom(
                                                    dateFrom.filter((x, i) =>
                                                        i !== idx
                                                    )
                                                );
                                                setDateUntil(
                                                    dateUntil.filter((x, i) =>
                                                        i !== idx
                                                    )
                                                );
                                                setBoothCounter(boothCounter - 1)
                                            }}
                                        >
                                            Remove
                                        </CButton>
                                    }
                                </Grid>
                                <CRow className="mb-3">
                                    <CCol xs={4}>
                                        <CFormLabel>
                                            Booth
                                        </CFormLabel>
                                    </CCol>
                                    <CCol xs={8}>
                                        <CFormSelect
                                            options={(idx == 0 && boothCounter <= 1) ? [ALL_BOOTH, ...boothOptions] : boothOptions}
                                            value={selectedBooths[idx]}
                                            onChange={(e) => {
                                                if (e.target.value == 0) {
                                                    setMerchantId([0])
                                                    setSelectedBooths([0])
                                                    return
                                                }
                                                const tmpMerchant = merchantId.map((x, i) => {
                                                    if (idx == i){
                                                        let mId = 0
                                                        boothOptions.forEach(option => {
                                                            if (option.value == e.target.value) {
                                                                mId = option.merchant_id
                                                            }
                                                        })
                                                        return mId
                                                    } else {
                                                        return x
                                                    }
                                                })
                                                setMerchantId(tmpMerchant)

                                                const tmpBooth = selectedBooths.map((x, i) => {
                                                    if (idx == i) {
                                                        return parseInt(e.target.value)
                                                    } else {
                                                        return x
                                                    }
                                                })
                                                setSelectedBooths(tmpBooth)
                                            }}
                                        />
                                    </CCol>
                                </CRow>
                                {(!applyDateForAll || idx == 0) &&
                                    <CRow className="mb-3">
                                        <CCol xs={4}>
                                            <CFormLabel>
                                                Time Period
                                            </CFormLabel>
                                        </CCol>
                                        <CCol xs={8}>
                                            <CFormSwitch
                                                value={isTimePeriod[idx]}
                                                checked={isTimePeriod[idx]}
                                                onChange={(e) => {
                                                    const tmp = isTimePeriod.map((x, i) => {
                                                        if (idx == i) {
                                                            return !isTimePeriod[idx]
                                                        } else {
                                                            return x
                                                        }
                                                    })
                                                    setIsTimePeriod(tmp)
                                                }}
                                            />
                                        </CCol>
                                    </CRow>
                                }
                                {isTimePeriod[idx] && (!applyDateForAll || idx == 0) &&
                                    <>
                                        <CRow className="mb-3">
                                            <CCol xs={4}>
                                                <CFormLabel>
                                                    Date From
                                                </CFormLabel>
                                            </CCol>
                                            <CCol xs={8}>
                                                <CFormInput
                                                    required
                                                    feedbackInvalid='This field cannot be empty'
                                                    type="date"
                                                    value={dateFrom[idx]}
                                                    onChange={(e) => {
                                                        const tmp = dateFrom.map((x, i) => {
                                                            if (idx == i) {
                                                                return e.target.value
                                                            } else {
                                                                return x
                                                            }
                                                        })
                                                        setDateFrom(tmp)
                                                    }}
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow className="mb-3">
                                            <CCol xs={4}>
                                                <CFormLabel>
                                                    Date Until
                                                </CFormLabel>
                                            </CCol>
                                            <CCol xs={8}>
                                                <CFormInput
                                                    required
                                                    feedbackInvalid='This field cannot be empty'
                                                    type="date"
                                                    value={dateUntil[idx]}
                                                    onChange={(e) => {
                                                        const tmp = dateUntil.map((x, i) => {
                                                            if (idx == i) {
                                                                return e.target.value
                                                            } else {
                                                                return x
                                                            }
                                                        })
                                                        setDateUntil(tmp)
                                                    }}
                                                />
                                            </CCol>
                                        </CRow>
                                    </>
                                }
                                <Divider className="mb-3"/>
                            </Grid>
                        ))}
                        <CRow>
                            {   selectedBooths[0] != 0 &&
                                <CButton
                                    variant="ghost"
                                    size="sm"
                                    onClick={e => {
                                        setBoothCounter(boothCounter + 1)
                                        setSelectedBooths([...selectedBooths, boothOptions[0].value])
                                        setMerchantId([...merchantId, boothOptions[0].merchant_id])
                                        if (applyDateForAll){
                                            setIsTimePeriod([...isTimePeriod, isTimePeriod[0]])
                                            setDateFrom([...dateFrom, dateFrom[0]])
                                            setDateUntil([...dateUntil, dateUntil[0]])
                                        } else {
                                            setIsTimePeriod([...isTimePeriod, false])
                                            setDateFrom([...dateFrom, ''])
                                            setDateUntil([...dateUntil, ''])
                                        }
                                    }}
                                >
                                    Tambahkan Booth
                                </CButton>
                            }
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter className="text-end">
                    <CButton type="submit" onClick={() => {handleSubmit()}}
                    >
                        Submit
                    </CButton>
                </CCardFooter>
            </CCard>
        </>
    )
}

export default AddFrameAssignment